import { render, staticRenderFns } from "./TableJSON.vue?vue&type=template&id=42cd494b&"
import script from "./TableJSON.vue?vue&type=script&lang=ts&"
export * from "./TableJSON.vue?vue&type=script&lang=ts&"
import style0 from "./TableJSON.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports